import { ReactElement } from 'react'
import { IconProps } from '../icons'

const NoEye = ({
  height = '20',
  width = '20',
  hardcodedColor = '#572F08',
  color,
  className = '',
  strokeWidth = '1.5',
  ...props
}: IconProps): ReactElement => {
  const colorClass = color ? `${`fill-${color}`}` : ''
  const fill = hardcodedColor && !color ? hardcodedColor : 'currentColor'

  return (
    <svg
      width={width}
      height={height}
      className={`${colorClass} ${className}`}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Invisible-1--Streamline-Core" clipPath="url(#clip0_3702_3977)" fill="none">
        <g id="invisible-1--disable-eye-eyeball-hide-off-view">
          <path
            id="Vector"
            d="M17.6733 17.9237C19.3184 16.2786 19.3184 13.6114 17.6733 11.9663C16.0282 10.3211 13.3609 10.3211 11.7158 11.9663"
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector 1859"
            d="M1.00293 1.25439L28.3847 28.6362"
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M7.12891 7.38008C9.32337 5.70427 11.9146 4.41357 14.6939 4.41357C20.5816 4.41357 25.6253 10.2059 27.8411 13.181C28.191 13.6648 28.3848 14.2934 28.3848 14.945C28.3848 15.5967 28.191 16.2253 27.8411 16.7091C26.6713 18.2798 24.7133 20.6358 22.2588 22.51"
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M3.54803 10.7324C2.74226 11.6296 2.06659 12.4828 1.54663 13.181C1.19665 13.6648 1.00293 14.2933 1.00293 14.945C1.00293 15.5967 1.19665 16.2252 1.54663 16.709C3.76245 19.6842 8.80607 25.4765 14.6938 25.4765C15.7535 25.4765 16.7859 25.2888 17.7794 24.9638"
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3702_3977">
          <rect width="30" height="30" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NoEye
